import { lazy } from 'react';
import { Navigate } from 'react-router';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import userTypes from 'constants/userTypes';
import { isPasswordEnabled } from 'utils/auth';
import SentryErrorBoundary from '../SentryErrorBoundary';

const Login = Loadable(lazy(() => import('views/authentication/auth-components/Login')));
const Redirect = Loadable(lazy(() => import('views/authentication/auth-components/Redirect')));
const RequireLogin = Loadable(lazy(() => import('views/authentication/auth-components/RequireLogin')));
const ForgotPassword = Loadable(lazy(() => import('views/authentication/auth-components/ForgotPassword')));
const ResetPassword = Loadable(lazy(() => import('views/authentication/auth-components/ResetPassword')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  errorElement: <SentryErrorBoundary />,
  children: [
    {
      path: '/',
      element: <Navigate to="/login" />
    },
    {
      path: '/login',
      element: <Login userType={userTypes.Admin} />
    },
    {
      path: '/login-manager',
      element: <Login userType={userTypes.Manager} />
    },
    {
      path: '/login-ext-user',
      element: <Login userType={userTypes.ExternalUser} />
    },
    {
      path: '/redirect',
      element: <Redirect />
    },
    ...(isPasswordEnabled
      ? [
          {
            path: '/forgot-password',
            element: <ForgotPassword />
          },
          {
            path: '/reset-password',
            element: <ResetPassword />
          }
        ]
      : []),
    {
      path: '*',
      element: <RequireLogin />
    }
  ]
};

export default AuthenticationRoutes;
